// src/context/stores/MessageUtils.ts
import { create } from "zustand";
var makeMessageUtilsStore = () => create((set) => {
  return {
    isCopied: false,
    setIsCopied: (value) => {
      set({ isCopied: value });
    },
    isHovering: false,
    setIsHovering: (value) => {
      set({ isHovering: value });
    }
  };
});
export {
  makeMessageUtilsStore
};
//# sourceMappingURL=MessageUtils.js.map